/* eslint-disable */
import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string'
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from "components/CustomButtons/Button.js";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import snackbarContentStyle from "assets/jss/material-dashboard-react/components/snackbarContentStyle.js";
import { AddAlert, AccountBox, Lock } from "@material-ui/icons";

import Spinner from 'components/Spinner.js';

snackbarContentStyle.root.maxWidth = 425;

const useStyles = makeStyles({
  card: {
    maxWidth: 450,
    border: '1px solid white',
  },
  title: {
    fontSize: 36,
    fontWeight: 200
  },
  subheader: {
    color: 'white',
    fontWeight: 200
  },
  input: {
    backgroundColor: 'white',
    marginLeft: '2%',
    width: '80%'
  },
  bgImage: {
    backgroundImage: `url('/loginPage.jpg')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    minHeight:'100vh',
    minWidth:'100vw',
    // backgroundRepeat: "no-repeat",
  }
});

export default (props) => {
  const classes = useStyles();

  return (
    <Login {...props} classes={classes}  />
  );
}

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      failure: false,
      showSpinner: false
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    var user = e.target.elements.username.value;
    var pass = e.target.elements.password.value;

    this.AttemptLogin(user, pass);
  }

  AttemptLogin = (user, pass) => {
    var $this = this;
    this.setState({showSpinner: true});
    fetch('/api/shared/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        username: user,
        password: pass
    })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          window.location.replace("/");
          // $this.setState({
          //   failure: true
          //  // user: data.data.user
          // })
        }
        else {
          $this.setState({
            //user: null
            failure: true,
            showSpinner: false
          })
        }
      });
  }

  render() {
    const classes = this.props.classes;

    return (
      <Box display='flex' alignItems='center' className={classes.bgImage}>
        <Grid container spacing={0} alignContent='center' direction='column'>
          <Grid item xs={12} >
            {
              //queryString.parse(this.props.location.search).failure === 'true' 
              this.state.failure ?
                <SnackbarContent
                  message={
                    <Fragment>
                      Incorrect email or password.
                    </Fragment>
                  }
                  color="danger"
                  icon={AddAlert}
                />
                : null
            }
          </Grid>
          <Grid item xs={12}>
            <Card className={classes.card} style={{ backgroundColor: "#F99621" }} variant='outlined' raised>
              <CardHeader classes={{ title: classes.title }} title="Welcome to IXIMS" subheader="Sign into your account" />
              <CardContent>
                <form method="POST" onSubmit={this.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        id="username"
                        classes={{ root: classes.input }}
                        name="username"
                        placeholder="Username"
                        variant="outlined"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccountBox />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="password"
                        classes={{ root: classes.input }}
                        name="password"
                        type="password"
                        placeholder="Password"
                        variant="outlined"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Lock />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Button color="info" type="submit">Login</Button>{ this.state.showSpinner ? <Spinner/> : ""}
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
              <CardActions>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  }
}